import { Component, ElementRef, OnInit } from '@angular/core';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'zaya-app';

  constructor(private authService: AuthService, private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.authService.autoLogin();
  }

  ngAfterViewInit() {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = '//js.hs-scripts.com/9144465.js';
    this.elementRef.nativeElement.appendChild(s);
  }
}
